/**
 * It takes a username and password, converts it to base64, and then sends it to the API to get a
 * token.
 * @returns The token
 */
import axios from "axios";
import { Buffer } from "buffer";

export let signIn = async () => {
  const usernamePasswordBuffer = Buffer.from(
    process.env.REACT_APP_PRODUCT_API_USER +
    ":" +
    process.env.REACT_APP_PRODUCT_API_PASSWORD
  );

  const base64data = usernamePasswordBuffer.toString("base64");
  try {
    const response = await axios.get(
      process.env.REACT_APP_ADMIN_API_URL + "/auth/login",
      {
        headers: {
          Authorization: `Basic ${base64data}`
        }
      },
      { data: {}, query: {} }
    );
    return response.data.token
  } catch (error) {
    return error;
  }
};
